<template>
  <div class="lr-thank-you" :class="{ 'is-donation': isDonation }">
    <h4>{{ thankYouText }}</h4>

    <div class="lr-ty-donation" v-if="isDonation">
      <p>
        <span class="in-focus"
          >{{ supporter.firstName }} {{ supporter.lastName }}</span
        >, thank you for your donation of
        <span class="in-focus">$ {{ donation.amount }}</span>
      </p>
      <p class="minimal">
        Please check your email for confirmation. If you don’t receive an email,
        please note that due to the high volume of donations we’ve received, it
        may take longer than normal for us to process your payment receipt.
      </p>
      <p class="minimal">
        For urgent questions, please call our supporter relations team on
        <a href="tel:1800032551">1800 032 551</a>.
      </p>
    </div>

    <div class="ls-ty-share">
      <p>
        {{ getSocialText }}
      </p>
    </div>

    <div class="gs-wrapper">
      <div class="getsocial gs-inline-group"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "ThankYou",

  computed: {
    ...mapGetters(["isDonation"]),
    ...mapState({
      supporter: (state) => state.leafRelief.details,
      donation: (state) => state.donation.donation,
    }),
  },
  props: {
    thankYouText: {
      type: String,
      default: "Thank you for helping repopulate our forests",
    },
    getSocialText: {
      type: String,
      default: "Share this opportunity with friends to let them plant their own seed",
    },
  },
};
</script>

<style scoped>
.lr-thank-you {
  padding: var(--lrPadding);
}

.lr-thank-you.is-donation {
  padding-top: 0;
}

.lr-thank-you h4 {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 42px;
  line-height: 42px;
  font-weight: 400;
  font-family: var(--wwfFont);
}

.lr-thank-you p {
  margin-bottom: 0;
  font-size: 18px;
  text-align: center;
}

.lr-ty-donation {
  margin-bottom: 2rem;
}

.lr-ty-donation p:first-child {
  margin-bottom: 1rem;
}

.in-focus {
  font-weight: 600;
}

p.minimal {
  margin-bottom: 0.5rem;
  font-size: 14px;
}

p.minimal a {
  color: var(--wwfRegenerateAustralia);
}

.ls-ty-share {
  margin-bottom: 1rem;
}
</style>

<style>
/* Get Social override - Not scoped because the icons are rendered after */

html
  .lr-thank-you
  .gs-wrapper
  .getsocial.gs-inline-group
  .gs-bar.gs-buttons
  a[class*="gs-"] {
  background: var(--wwfRegenerateAustralia);
}

html
  .lr-thank-you
  .gs-wrapper
  .getsocial.gs-inline-group
  .gs-bar.gs-buttons
  a[class*="gs-"]
  i::before {
  color: var(--wwfWhite);
}
</style>


// WEBPACK FOOTER //
// ThankYou.vue?e38d6092